import { ILocation } from "@montana/shared/map";

/*
    Haversine Formula
    used to calculate the great circle distance between two points on the earth (specified in decimal degrees)
*/
export function computeDistance(pointA: ILocation, pointB: ILocation) {
    const lat1 = pointA.lat;
    const lon1 = pointA.lng;

    const lat2 = pointB.lat;
    const lon2 = pointB.lng;

    const R = 6371e3; // earth radius in meters
    const φ1 = lat1 * (Math.PI / 180);
    const φ2 = lat2 * (Math.PI / 180);
    const Δφ = (lat2 - lat1) * (Math.PI / 180);
    const Δλ = (lon2 - lon1) * (Math.PI / 180);

    const a = (Math.sin(Δφ / 2) * Math.sin(Δφ / 2)) +
        ((Math.cos(φ1) * Math.cos(φ2)) * (Math.sin(Δλ / 2) * Math.sin(Δλ / 2)));

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c;
    return Math.round((distance / 1000 + Number.EPSILON) * 100) / 100; // in kms
}
